import { css } from 'styled-components';

export const inputSizeStyle = css`
  border-radius: 8px;
  border: 2px solid ${({ theme }) => theme.colors.genericSelectorInputSize};
  background: ${({ theme }) => theme.colors.palette.white};
  margin: 0px;

  ${({ isSoldOut }) =>
    isSoldOut &&
    css`
      && {
        border-color: ${({ theme }) =>
          theme.colors.soldOutSelectorItemSizeInput};
        background: ${({ theme }) =>
          theme.colors.genericSelectorInputSizeSoldOut};
        color: ${({ theme }) => theme.colors.inputSizeSelectorSoldOut};
        overflow: hidden;
        position: relative;
        &:before {
          background: linear-gradient(
            to top left,
            transparent calc(50% - 1px),
            ${({ theme }) => theme.colors.soldOutSelectorItemSizeInput}
              calc(50% - 1px),
            ${({ theme }) => theme.colors.soldOutSelectorItemSizeInput}
              calc(50% + 1px),
            transparent calc(50% + 1px),
            transparent
          );
        }
      }
    `}

  input:checked + && {
    background-color: ${({ theme }) => theme.colors.palette.black};
    border-color: ${({ theme }) => theme.colors.palette.black};
  }
`;

export const swatchLabelStyle = css`
  position: static;
  font-size: 12px;
  line-height: 1;
  max-width: 40px;
  color: ${({ theme }) => theme.colors.swatchTagLabel};
}`;

export const itemSizeLabelStyle = css`
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  position: absolute;
  right: 0;
  left: 0;
  text-transform: uppercase;
  ${({ isChecked }) =>
    isChecked &&
    css`
      color: ${({ theme }) => theme.colors.palette.white};
    `}
  ${({ isSoldOut }) =>
    isSoldOut &&
    css`
      color: ${({ theme }) => theme.colors.soldOutSelectorItemSizeLabel};
    `}
`;

export const itemSoldOutStyle = css`
  background: ${({ theme }) => theme.colors.genericSelectorItemSoldOutBg};
`;
